
<div *ngIf="vademecum">
  <table>
    <tr>
      <td>
          Study Dutch at school: 
      </td>
      <td>
          {{vademecum.studyDutchInSchool}}
      </td>
    </tr>
    <tr *ngIf="vademecum.studyDutchInSchool">
      <td>
        Dutch study years: 
      </td>
      <td>
        {{vademecum.dutchStudyYears}}
      </td>
    </tr>
    <tr *ngIf="vademecum.studyDutchInSchool">
      <td>Dutch study hours/week: </td>
      <td>
        {{vademecum.dutchStudyHours}}
      </td>
    </tr>
    <tr *ngIf="vademecum.studyDutchInSchool">
      <td>
        Dutch teacher name: 
      </td>
      <td>
          {{vademecum.dutchTeacherName}}
        </td>
    </tr>
    <tr>
      <td>
          Study English at school: 
      </td>
      <td>
          {{vademecum.studyEnglishInSchool}}
      </td>
    </tr>
    <tr *ngIf="vademecum.studyEnglishInSchool">
      <td>
        English study years: 
      </td>
      <td>
        {{vademecum.englishStudyYears}}
      </td>
    </tr>
    <tr *ngIf="vademecum.studyEnglishInSchool">
      <td>
        English study hours/week: 
      </td>
      <td>
        {{vademecum.englishStudyHours}}
      </td>
    </tr>
    <tr *ngIf="vademecum.studyEnglishInSchool">
      <td>
        English teacher name: 
      </td>
      <td>
        {{vademecum.englishTeacherName}}
      </td>
    </tr>
    <tr>
      <td>
          Study French at school: 
      </td>
      <td>
          {{vademecum.studyFrenchInSchool}}
      </td>
    </tr>
    <tr *ngIf="vademecum.studyFrenchInSchool">
      <td>
        French study years: 
      </td>
      <td>
        {{vademecum.frenchStudyYears}}
      </td>
    </tr>
    <tr *ngIf="vademecum.studyFrenchInSchool">
      <td>
        French study hours/week: 
      </td>
      <td>
        {{vademecum.frenchStudyHours}}
      </td>
    </tr>
    <tr *ngIf="vademecum.studyFrenchInSchool">
      <td>
        French teacher name: 
      </td>
      <td>
        {{vademecum.frenchTeacherName}}
      </td>
    </tr>
  </table>
  <div>
    Coming with friend: {{vademecum.isComingWithFriends}}
  </div>
  <div>
    Language test date: {{vademecum.languageTestDate}}
  </div>
</div>

